<!-- 服务支持 -->
<template>
    <div class="services_advice">
      <!-- <div class="header_img"></div> -->
       <sub-banner id="id_about">
        <img src="../../assets/images/services/product_top.png"/>
      </sub-banner>
      <div class="content_product">
         <div class="content_title">
             <span>{{$t('services.type')}}</span>
         </div>
         <div class="type_content">{{$t('services.type_content')}}</div>
      </div>

      <div class="service_process">
          <div class="process_content">
            <div class="process_title">{{$t('services.process')}}</div>
            <div class="process_group">
              <div class="process_item">
                  <div class="process_item_img">
                      <img src="../../assets/images/services/guifan.png" />
                  </div>
                  <div class="process_titles">{{$t('services.process_item_1_title')}}</div>
                  <div class="process_item_content">{{$t('services.process_item_1_content')}}</div>
              </div>
               <div class="process_item">
                  <div class="process_item_img">
                      <img src="../../assets/images/services/jiemian.png" />
                  </div>
                  <div class="process_titles">{{$t('services.process_item_2_title')}}</div>
                  <div class="process_item_content">{{$t('services.process_item_2_content')}}</div>
              </div>
               <div class="process_item">
                  <div class="process_item_img">
                      <img src="../../assets/images/services/jishu.png" />
                  </div>
                  <div class="process_titles">{{$t('services.process_item_3_title')}}</div>
                  <div class="process_item_content">{{$t('services.process_item_3_content')}}</div>
              </div>
               <div class="process_item">
                  <div class="process_item_img">
                      <img src="../../assets/images/services/ceshi.png" />
                  </div>
                  <div class="process_titles">{{$t('services.process_item_4_title')}}</div>
                  <div class="process_item_content">{{$t('services.process_item_4_content')}}</div>
              </div>
          </div>
          </div>
         
      </div>

      <div class="service_center">
          <div class="process_content">
            <div class="process_title">{{$t('services.center')}}</div>
            <div class="process_group">
              <div class="process_item">
                  <div class="process_item_img_center">
                      <img src="../../assets/images/services/dianhua.png" />
                  </div>
                  <div class="process_item_content_center">{{$t('services.center_1_title')}}</div>
              </div>
               <div class="process_item">
                  <div class="process_item_img_center">
                      <img src="../../assets/images/services/fankui.png" />
                  </div>
                  <div class="process_item_content_center">{{$t('services.center_2_title')}}</div>
              </div>
               <div class="process_item">
                  <div class="process_item_img_center">
                      <img src="../../assets/images/services/jindu.png" />
                  </div>
                  <div class="process_item_content_center">{{$t('services.center_3_title')}}</div>
              </div>
               <div class="process_item">
                  <div class="process_item_img_center">
                      <img src="../../assets/images/services/shouhou.png" />
                  </div>
                  <div class="process_item_content_center">{{$t('services.center_4_title')}}</div>
              </div>
          </div>
          </div>
         
      </div>
    </div>
</template>

<script>
import { concatMeta } from '@/config/metaJson.js'

import SubBanner from "@/components/sub-banner";
export default {
  name: 'concat',
  metaInfo () {
    return {
      title: this.pageTitle,
      meta:[{
        name:this.metaName,
        content:this.metaContent,
        keyword:this.keyword,
        description:this.description
      }]
    }
  },
  components: {SubBanner},
  data () {
    return {
      pageTitle: '广州市熵达贸易有限公司-服务支持',
      metaName:'广州市熵达贸易有限公司-服务支持',
      metaContent:'广州市熵达贸易有限公司-服务支持',
      keyword:'广州市熵达贸易有限公司,熵达贸易,熵达',
      description:'广州市熵达贸易有限公司' ,   
      
    };
  },
  computed: {},
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou entropy Da Trade Co., Ltd',
        'zh-TCC': '廣州市熵達貿易有限公司',
        'zh-CN': '广州市熵达贸易有限公司'
      }
      this.pageTitle = obj[nval]
    }
  },
  methods: {

  },
  created () {

  },
  mounted () {
  },
}
</script>
<style lang='scss' scoped>
.services_advice{
.header_img{
  width: 100%;
  height: 300px;
//   padding-top: 96px;
//   padding-left: 31px;
  background: url('~@/assets/images/services/product_top.png') no-repeat;
  background-size: 100% 100%;
  text-align: left;
  
}
.content_product{
  margin-top: 100px;
  text-align: center;
  margin-bottom:120px;
  padding:0 40px;
  .content_title{
    font-size: 30px;
	font-weight: bold;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
    margin-bottom:68px;
  }
  .type_content{
    font-size: 22px;
	color: #333333;
  }

   
      
}


.service_process{
    background: url('~@/assets/images/services/beijing.png') no-repeat;
    background-size: 100% 100%;
    .process_content{
        padding-top:90px;
        padding-bottom:106px;
        .process_title{
            font-size: 30px;
            font-weight: bold;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #333333;
        }
        
        .process_group{
            width:74%;
            margin:auto;
            padding-top:70px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            // justify-content: space-between;
            flex-direction: row;
            .process_item{
               padding-right:50px;
               display: flex;
               flex-direction: column;
               align-items: center;
               justify-content: center;
               max-width:305px;
               margin-top:45px;
               .process_item_img{
                    image{
                      width: 66px;
                      height: 66px;
                    }
               }
               .process_titles{
                    margin-top:64px;
                   	font-size: 26px;
                    font-weight: bold;
                    letter-spacing: 0px;
                    color: #333333;
               }
               .process_item_content{
                   padding-top:20px;
                   font-size: 21px;
                   letter-spacing: 0px;
                   color: #333333;
               }
            }
        }
    }
}

.service_center{


    .process_content{
        padding-top:112px;
        padding-bottom:129px;
        .process_title{
            font-size: 30px;
            font-weight: bold;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #333333;
        }
        
        .process_group{
            width:74%;
            margin:auto;
            padding-top:70px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            // justify-content: space-between;
            // flex-direction: row;
            .process_item{
               margin-left:50px;
               display: flex;
               flex-direction: column;
               align-items: center;
               justify-content: center;
               max-width:285px;
               margin-top:45px;
               &:first-child{
                 margin-left:0px !important;
               }
               .process_item_img_center{
                    image{
                      width: 90px;
                      height: 90px;
                    }
               }
               .process_item_content_center{
                   padding-top:46px;
                   font-size: 21px;
                   letter-spacing: 0px;
                   color: #333333;
               }
            }
        }
    }
}

}
        
</style>
<style>

/* 超小屏幕（手机，小于 768px） */
/* 没有任何媒体查询相关的代码，因为这在 Bootstrap 中是默认的（还记得 Bootstrap 是移动设备优先的吗？） */

/* 小屏幕（平板，大于等于 768px） */
@media (min-width: @screen-sm-min) { 
   
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media (min-width: @screen-md-min) { 

 }

/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: @screen-lg-min) { 

}
@media (max-width: 500px){
   .service_center .process_item{
     margin-left:0px !important;
   }
   .service_center .process_group{
      width:40% !important;
   }
   .service_process .process_item{
     margin-right:0px !important;
   }
   .service_process .process_group{
      width:45% !important;
   }
}
@media (min-width: 500px) and  (max-width: 750px){
  
}
@media (min-width: 750px) and (max-width: 860px){

}
@media (min-width: 860px) and (max-width:1200px){
  
    
}
@media (min-width: 1780px){                  
  
    
 
}
@media (min-width: 1200px) and (max-width:1280px){
  
    
}
@media (min-width: 1270px) and (max-width: 1450px){                  
  
    
 
}
@media (min-width: 1450px) and (max-width: 1780px){                  
  
    
 
}


</style>



// WEBPACK FOOTER //
// src/view/services/index.vue